import { EnumWithDescription, ICustomEnumValue } from "../EnumWithDescription";

export enum DeviceStatusEnum {
    Active = 1,
    Inactive = 2
}
class DeviceStatusClass extends EnumWithDescription<DeviceStatusEnum> {
    public readonly enum = DeviceStatusEnum;
    public readonly enumName: string = "DeviceStatusEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<DeviceStatusEnum>> = new Map([
        [
            "Active",
            {
                value: DeviceStatusEnum.Active,
                name: "Active"
            }
        ],
        [
            "Inactive",
            {
                value: DeviceStatusEnum.Inactive,
                name: "Inactive"
            }
        ]
    ]);
}

export const DeviceStatuses = new DeviceStatusClass();
